import {
  sampleColumnsCreator,
  SamplesColumnsBaseProps,
} from './sampleColumnsCreator';
import { createColumnHelper } from '@tanstack/react-table';
import { Sample } from '@texas/api/endpoints/samplesApi';
import { SampleState } from '@texas/components/shared/samples/SampleState';
import { dateFromNow } from '@texas/utils/helpers/dateHelper';
import { Locale } from '@texas/i18n/types';
import { RejectReasons } from '@texas/components/article/productApproval/shared/RejectReasons';
import { ensureEnumNumber } from '@texas/utils/helpers/enumHelpers';
import { SampleLifecycle } from '@texas/components/shared/samples/types';

export const samplesHandledColumns = (props: SamplesColumnsBaseProps) => {
  const columnHelper = createColumnHelper<Sample>();
  const columns = [
    columnHelper.accessor('lifecycle', {
      cell: (info) => {
        const sample = info.row.original;
        return (
          <SampleState
            lifecycle={ensureEnumNumber(SampleLifecycle, sample.lifecycle)}
            sampleReadyDate={sample.sampleReadyDate ?? null}
          />
        );
      },
      header: props.t('general.state'),
      maxSize: 100,
      meta: { toggleable: true, defaultVisible: true },
    }),
    columnHelper.accessor('productApproval.handleReason', {
      cell: (info) => {
        return <RejectReasons reasons={info.getValue()} />;
      },
      header: props.t('productApproval.reason'),
      enableSorting: false,
      meta: { toggleable: true, defaultVisible: true },
    }),
    columnHelper.accessor('productApproval.handledDate', {
      cell: (info) =>
        info.getValue() !== null
          ? dateFromNow(Locale.EnDate, info.getValue()!)
          : '',
      header: props.t('general.when'),
      meta: { toggleable: true, defaultVisible: true },
    }),
    columnHelper.accessor('productApproval.handledBy', {
      cell: (info) => info.getValue(),
      header: props.t('general.by'),
      meta: { toggleable: true, defaultVisible: true },
    }),
  ];

  return sampleColumnsCreator({
    t: props.t,
    columns: { afterIndex: 7, columns },
    hideStopFollowing: props.hideStopFollowing,
  });
};
